// extracted by mini-css-extract-plugin
module.exports = {"BreadcrumbWrapper":"breadcrumbs_BreadcrumbWrapper__c3s2o","slash":"breadcrumbs_slash__Vva7x"};